/**
 * スクロールコンテンツに関する処理を記述します。
 * @returns { void }
 */
export const scrollContents = () => {
  /**
   * スクロールコンテンツを開閉する処理
   * （スマホのみの挙動）
   */
  const elements = document.querySelectorAll( '.p-scroll-contents' );

  elements.forEach( item => {
    const toggleButton = item.querySelector( '.p-scroll-contents__open' );

    toggleButton.addEventListener( 'click', function () {
      if ( item.classList.contains( 'is-open' ) ) {
        item.classList.remove( 'is-open' );
      } else {
        item.classList.add( 'is-open' );
      }
    } );
  } );

  /**
   * スクロールコンテンツを全て読んだら同意チェックが活性化する処理
   */
  const reflect = () => {
    const targets = document.querySelectorAll( '.p-scroll-contents' ) || false;
    if ( ! targets ) return false;
    let cnt = 0;
    targets.forEach( item => {
      if ( ! item.classList.contains( 'is-read' ) ) {
        cnt++;
      }
    } );

    if ( cnt == 0 ) {
      agreeInput.closest( '.p-selection' ).style.pointerEvents = 'auto';
      agreeText.style.color = '#141d1d';
    }
  }

  const scrollContents = document.querySelectorAll( '.p-scroll-contents' ) || false;
  const agreeInput = document.querySelector( 'input[data-agreement]' ) || false;
  const agreeText = document.querySelector( 'input[data-agreement] + span' ) || false;
  if ( ! scrollContents ) return false;
  if ( ! agreeInput ) return false;
  agreeInput.closest( '.p-selection' ).style.pointerEvents = 'none';
  agreeText.style.color = '#CCC';
  // ↑ ここまで、同意チェックを非活性にする処理

  scrollContents.forEach( item => {
    const content = item.querySelector( '.p-scroll-contents__inner' );
    const contentHeight = content.clientHeight;
    const scrollContentHeight = content.scrollHeight;

    if (window.matchMedia( "(min-width: 768px)" ).matches) {
      if ( contentHeight == scrollContentHeight ) {
        item.classList.add( 'is-read' );
      }
      content.addEventListener( 'scroll', ( e ) => {
        if ( e.target.scrollTop + contentHeight >= scrollContentHeight - 5 ) {
          item.classList.add( 'is-read' );
        }
        reflect();
      } );
      reflect();
    } else {
      item.querySelector( '.p-scroll-contents__open' ).addEventListener( 'click', () => {
        item.classList.add( 'is-read' );
        reflect();
      } );
    }
  } );
}
